export default {
  styleOverrides: {
    label: {
      fontSize: "16px",
    },
  },
};
